import { G } from "../../styles/theme";

export default function Snack({ msg }) {
  if (!msg) return null;
  return (
    <div style={{ position: "fixed", bottom: 26, right: 26, background: G.orange, color: "#fff", padding: "13px 24px", borderRadius: 12, fontSize: 14, fontWeight: 700, zIndex: 9999, boxShadow: "0 8px 24px rgba(232,89,60,.4)" }}>
      ✓ {msg}
    </div>
  );
}
